<template>
    <div></div>
</template>

<script>
export default {
    name: "CruiseWatch",
    beforeMount() {
        let path = location.pathname.replace('Rccl.UserCenter', 'Rccl.RecommendCruise')
        let url = path + location.search
        location.href = `${process.env.VUE_APP_BASE_URL}${url}`
    }
}
</script>